import type { Session } from 'next-auth'

/**
 * The signed-in user's first name for the header user menu only: copy never
 * addresses the user by name (decision log 2026-10-05). Keycloak `given_name`,
 * else the first word of the display name, else an empty string.
 */
export function sessionFirstName(session: Session | null | undefined): string {
  const given = session?.givenName?.trim()
  if (given) return given
  return session?.user?.name?.trim().split(/\s+/)[0] ?? ''
}
